import { CanActivateFn, Router } from '@angular/router';
import { UserRole } from '@app/core/models/user-role';
import { inject } from '@angular/core';
import { AuthService } from '@app/core/services/auth.service';

export function roleGuard(...allowedRoles: UserRole[]): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    if (auth.hasAnyRole(allowedRoles)) {
      return true;
    }

    return router.createUrlTree(['/unauthorized']);
  };
}
